<template>
  <v-container class="ma-0 pa-0 mt-5">
    <v-skeleton-loader type="paragraph@3" :loading="loading">
      <v-data-iterator
        v-if="notes.length > 0"
        :items="notes"
        :footer-props="{
          'items-per-page-options': [itemsPerPage, -1],
          'disable-items-per-page': true
        }"
        :items-per-page.sync="itemsPerPage"
        :hide-default-footer="notes.length <= itemsPerPage"
      >
        <template #default="props">
          <v-row>
            <v-col v-for="item in props.items" :key="item.id" cols="12">
              <notes-list-note :note="item" @submit:success="$emit('reload')" />
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
      <figure v-else class="text-center">
        <img
          :src="require('../assets/no-data.svg')"
          :alt="$t('fresh-vue-notes.misc.no-data')"
          style="width: 75%"
        />
        <figcaption>
          {{ $t('fresh-vue-notes.misc.no-data') }}
        </figcaption>
      </figure>
    </v-skeleton-loader>
  </v-container>
</template>

<script>
import NotesListNote from './NotesListNote'

export default {
  name: 'NotesList',

  components: {
    NotesListNote
  },

  props: {
    notes: {
      type: Array,
      required: false,
      default: () => []
    },

    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      itemsPerPage: 3
    }
  },

  computed: {}
}
</script>
